import { ApiCrudObjectControllerBindings, HouseholdYearCrudController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Edit / actions user interface for a year specific household deductions.
 * @example
 * ```html
 * <salaxy-household-year-details model="'url'"></salaxy-household-year-details>
 * ```
 */
export class HouseholdYearDetails extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = new ApiCrudObjectControllerBindings();

    /** Uses the HouseholdYearCrudController */
    public controller = HouseholdYearCrudController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/personal/HouseholdYearDetails.html";

}
